import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { adminTheme } from '@commander/ui';

import { routeTree } from './routeTree.gen';
import { EventStreamProvider } from './providers';

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  // Disable SSE when using mock API (no server to connect to)
  const enableSSE = import.meta.env.VITE_MOCK_API !== 'true';

  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={adminTheme} defaultColorScheme="light">
        <Notifications position="top-right" />
        <EventStreamProvider enabled={enableSSE}>
          <RouterProvider router={router} />
        </EventStreamProvider>
      </MantineProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
